import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ICU from 'i18next-icu';
import { initReactI18next } from 'react-i18next';

import { Languages, SUPPORTED_LANGUAGES } from './constants';
import staticEn from './locales/static.en.json';
import staticKz from './locales/static.kz.json';
import staticRu from './locales/static.ru.json';

const resources = {
  en: { translation: staticEn },
  ru: { translation: staticRu },
  kz: { translation: staticKz }
};

const fallbackLanguage = localStorage.getItem('i18nextLng') || Languages.kz;

i18next
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: fallbackLanguage,
    supportedLngs: SUPPORTED_LANGUAGES,
    detection: {
      // Порядок определения языка
      order: ['path', 'localStorage', 'navigator', 'subdomain'],
      // Извлечение языка из первого сегмента пути (/:lang)
      lookupFromPathIndex: 0
    },
    interpolation: {
      escapeValue: false // React самостоятельно экранирует значения
    }
  });

export default i18next;
